/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIBillingTypeFromJSON, ApiAIBillingTypeToJSON, } from './ApiAIBillingType';
export function ApiBillingFromJSON(json) {
    return ApiBillingFromJSONTyped(json, false);
}
export function ApiBillingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'cost': !exists(json, 'cost') ? undefined : json['cost'],
        'type': !exists(json, 'type') ? undefined : ApiAIBillingTypeFromJSON(json['type']),
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}
export function ApiBillingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'Name': value.name,
        'cost': value.cost,
        'type': ApiAIBillingTypeToJSON(value.type),
        'version': value.version,
    };
}
